import { TextField, Typography, Box } from "@mui/material";
import PropTypes from "prop-types";

function CustomTextField({ label, required, ...props }) {
  return (
    <Box mb={2}>
      {/* Label riêng nằm bên ngoài */}
      <Typography fontWeight="bold" fontSize="16px" mb={0.5} color="text.primary">
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </Typography>

      <TextField
        fullWidth
        variant="outlined"
        {...props}
        InputProps={{
          sx: {
            height: "40px !important",
            borderRadius: "8px",
            backgroundColor: "#fff",
            fontSize: "14px",
            paddingY: "6px",
            paddingX: "12px",
          },
          ...props.InputProps,
        }}
        InputLabelProps={{
          shrink: true,
          ...props.InputLabelProps,
        }}
      />
    </Box>
  );
}

CustomTextField.propTypes = {
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  InputProps: PropTypes.shape({}),
  InputLabelProps: PropTypes.shape({}),
};

CustomTextField.defaultProps = {
  required: false,
  InputProps: {},
  InputLabelProps: {},
};

export default CustomTextField;
